import { useEffect, useState } from 'react';
import removeSubImg from '../assets/icHeaderSearchCancle16W.png';
import removeImg from '../assets/icHeaderSearchDelete12W.png';

export default function InputFiles({
  label = '업로드',
  inputId,
  placeholder,
  value = '',
  setValue,
  required = false,
  isValid,
  setIsValid = () => {},
  isEdit = false,
  setImageCount,
  showErrors = false,
}) {
  const [validText, setValidText] = useState('');
  const [previews, setPreviews] = useState([]);
  const [touched, setTouched] = useState(false);
  const hasRequiredFiles = Array.isArray(value)
    ? value.some((file) => file && file.change !== 2)
    : Boolean(value);

  useEffect(() => {
    if (required && !hasRequiredFiles) {
      return setValidText('파일을 첨부해주세요.');
    }

    setValidText('');
  }, [required, hasRequiredFiles, value]);

  useEffect(() => {
    // console.log(value);
  }, [value]);

  const setImageFromFile = async (file) => {
    const base64Image = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });

    return base64Image;
  };

  const removeImage = (idx) => {
    const tempImages = [...value];
    tempImages.splice(idx, 1);

    const tempPreviews = [...previews];
    tempPreviews.splice(idx, 1);

    setValue(tempImages);
    setImageCount(tempImages.length);
    setPreviews(tempPreviews);

    if (required && tempImages.length === 0) {
      setIsValid(false);
    }
  };

  const removeUploadedImage = (idx) => {
    const tempImages = [...value];
    tempImages[idx].change = 2;

    setValue(tempImages);

    // Check if any valid images remain
    const validImagesCount = tempImages.filter((img) => img.change !== 2).length;
    if (required && validImagesCount === 0) {
      setIsValid(false);
    }
  };

  return (
    <>
      <div className="w-full grid grid-cols-1 md:grid-cols-[minmax(160px,1fr)_minmax(0,3fr)_minmax(160px,1fr)] gap-2 md:gap-4 items-center mb-2">
        <label htmlFor={inputId} className="text-explorer font-semibold text-base">
          {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
        </label>
        <button
          type="button"
          className="min-w-0 w-full text-center font-bold text-giver rounded-lg border border-pioneer cursor-pointer"
          onClick={() => {
            setTouched(true);
            document.getElementById(inputId)?.click();
          }}
        >
          {placeholder}
        </button>
        <input
          multiple
          id={inputId}
          type="file"
          accept="image/*"
          className="hidden"
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            if (!e.target.files || e.target.files.length === 0) return;
            if (inputId === 'productImages') {
              if (e.target.files.length > 10) {
                return alert('상품 대표 이미지는 10장을 초과할 수 없습니다.');
              }
            } else if (inputId === 'productDescribeImages') {
              if (e.target.files.length > 15) {
                return alert('상품 상세 이미지는 15장을 초과할 수 없습니다.');
              }
            }

            if (e.target.files.length > 0) {
              const images = [];
              for (let i = 0; i < e.target.files.length; i++) {
                const image = await setImageFromFile(e.target.files[i]);

                if (isEdit) {
                  e.target.files[i].change = 1;
                }
                images.push(image);
              }

              setPreviews(images);
              setImageCount(images.length);
              setValue([...value, ...e.target.files]);
            }

            setIsValid(true);
          }}
        />
        <div className="text-red-400 text-sm">{(touched || showErrors) && (isValid === false || !hasRequiredFiles) ? validText : ''}</div>
      </div>
      <div className="flex flex-row">
        {previews.length > 0
          ? previews.map((preview, idx) => (
              <div key={`${preview.slice(20, 40)}_${idx}`}>
                <button className="absolute" onClick={() => removeImage(idx)}>
                  <img src={removeImg} alt="" />
                </button>
                <img className="w-28 h-28 mr-2 rounded-lg" src={preview} alt="" />
              </div>
            ))
          : null}
        {isEdit && value.length
          ? value.map((attachment, idx) => {
              if (attachment.url && attachment?.change !== 2) {
                return (
                  <div key={`${attachment.url.slice(0, 20)}_${idx}`}>
                    <button className="absolute" onClick={() => removeUploadedImage(idx)}>
                      <img src={removeImg} alt="" />
                    </button>
                    <img className="w-28 h-28 mr-2 rounded-lg" src={attachment.url} alt="" />
                  </div>
                );
              }
            })
          : null}
      </div>
    </>
  );
}
